/* eslint-disable import/no-cycle */
import store from '../store';

function buildConfig({ 
  config, age, role, 
}) {
  const buildedConfig = [];

  config.forEach((el) => {
    if (el.age) {
      if (el.age === age) {
        buildedConfig.push(el);
      }
    } else if (el.role) {
      if (el.role === role) {
        buildedConfig.push(el);
      }
    } else {
      buildedConfig.push(el);
    }
  });

  if (!store.getState().steps.withoutMail) {
    buildedConfig.push({
      name: 'mail',
    });
  }

  return buildedConfig;
}

export default buildConfig;
